export interface FAQItem {
    question: string;
    answer: string;
}

export interface SeoSchemaFAQProps {
    qas: FAQItem[];
}

const stripHtml = (html: string): string => {
    let s = html;
    s = s.replace(/<br\s*\/?\s*>/gi, "\n");
    s = s.replace(/<\/(p|div|li|h[1-6]|section|article|tr|blockquote)\s*>/gi, "\n\n");
    s = s.replace(/<[^>]+>/g, "");
    s = s
        .replace(/&nbsp;/g, " ")
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'");
    s = s.replace(/[ \t]+/g, " ");
    s = s.replace(/\n{3,}/g, "\n\n");
    return s.split("\n").map((line) => line.trim()).join("\n").trim();
};

export function SeoSchemaFAQ({qas}: SeoSchemaFAQProps) {
    if (!qas.length) return null;

    const schema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "speakable": {
            "@type": "SpeakableSpecification",
            "cssSelector": [".faq-question", ".faq-answer"],
        },
        "mainEntity": qas.map((qa) => ({
            "@type": "Question",
            "name": stripHtml(qa.question),
            "acceptedAnswer": {
                "@type": "Answer",
                "text": stripHtml(qa.answer),
            },
        })),
    };

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{__html: JSON.stringify(schema)}}
        />
    );
}
